import React from "react";
import "./ServiceCard.css";

const ServiceCard = ({ s_one, s_two, s_three, s_four }) => {
  return (
    <div className="service-feature-card-container">
      <div className="service-feature-card services">
        <h2>Our Services Include</h2>
        <ul>
          <li>{s_one}</li>
          <li>{s_two}</li>
          <li>{s_three}</li>
          <li>{s_four}</li>
        </ul>
      </div>
    </div>
  );
};

export default ServiceCard;
